import axiosInstance from "./axiosInstance";
import { AxiosError } from "axios";

export type AccountDeletionInfo = { loginType: number; nonce: string };
export type AccountDeletionProof = { password?: string; credential?: string; nonce?: string };

class AccountDeletionError extends Error {
  constructor(public code?: number, message?: string) {
    super(message || "Account deletion request failed");
  }
}

const request = async (path: string, data: object, token: string) => {
  let response;
  try {
    response = await axiosInstance.post(path, data, {
      headers: { Authorization: token },
    });
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      throw new AccountDeletionError(error.response.data?.error, error.response.data?.errorDetail?.message);
    }
    throw error;
  }
  if (response.data.error) {
    throw new AccountDeletionError(response.data.error, response.data.errorDetail?.message);
  }
  return response.data;
};

export const getAccountDeletionInfo = async (token: string): Promise<AccountDeletionInfo> =>
  request("/customer/getAccountDeletionInfo", {}, token);

export const deleteMyAccount = async (proof: AccountDeletionProof, token: string): Promise<void> => {
  const result = await request("/customer/deleteMyAccount", proof, token);
  if (result.success !== true) throw new Error("Account deletion failed");
};
